import React from 'react';
import './uploadFailed.scss';
import { lang } from '@umu/ukit-lang';
import { Button } from '@umu/umu-design';
import { replaceNumText } from '../../util';
import { DownloadType } from '../../interface';

export interface IUploadFailedProps {
    totalNumber: number;
    failedNumber: number;
    children?: JSX.Element;
    callback?: VoidFunction;
    uploadFile: VoidFunction;
    downFile: (types: DownloadType) => void;
    customFailMsg?: (totalNumber: number, failedNumber?: number) => JSX.Element;
}

function UploadFailed(props: IUploadFailedProps) {
    const { totalNumber, failedNumber, uploadFile, downFile, children, customFailMsg } = props;

    const renderFailMsg = () => {
        if (customFailMsg) {
            return customFailMsg(totalNumber, failedNumber);
        }

        const text = lang(
            '{$0{0=条,1=条}}导入成功，{$1{0=条,1=条}}导入失败。您可以下载失败记录查看所有失败数据，修改后重新上传。',
            `${totalNumber - failedNumber}`,
            `${failedNumber}`,
        );
        return replaceNumText(text, 'upload-success-num-msg', 'upload-failed-num-msg');
    };

    const renderEmpty = () => {
        return (
            <>
                <div className="msg-show">
                    <div className="icon-fail" />
                    <div className="msg-desc">{lang('数据存在错误')}</div>
                </div>
                <p className="tooltip-msg">{lang('系统未知错误')}</p>
                <div className="btn-rows">
                    <Button type="primary-blue" className="toolbar-input-col" onClick={uploadFile}>
                        {lang('重新上传')}
                    </Button>
                </div>
            </>
        );
    };

    const renderHaveData = () => {
        return (
            <>
                <div className="msg-show">
                    <div className="icon-fail" />
                    <div className="msg-desc">{lang('数据存在错误')}</div>
                </div>
                <p className="tooltip-msg" dangerouslySetInnerHTML={{ __html: renderFailMsg() as string }}></p>
                <div className="btn-rows">
                    <Button type="ghost-blue" className="toolbar-input-col" onClick={uploadFile}>
                        {lang('再次上传')}
                    </Button>
                    <Button
                        type="primary-blue"
                        onClick={() => {
                            downFile(DownloadType.errorRecord);
                        }}
                    >
                        {lang('下载失败记录')}
                    </Button>
                </div>
                {children}
            </>
        );
    };

    return <div className="fail-desc">{Number(failedNumber) === 0 ? renderEmpty() : renderHaveData()}</div>;
}

export default UploadFailed;
